/**
 * Post Category Constants
 * Centralized constants for post categories used across web and mobile
 */

// Category enum values
export const POST_CATEGORIES = {
  GENERAL: "general",
  EVENT: "event",
  SAFETY: "safety",
  CONTRACT: "contract",
  TRAINING: "training",
  SOCIAL: "social",
  EMERGENCY: "emergency",
  GRIEVANCE_UPDATE: "grievance_update",
  FINANCIAL: "financial",
  POLITICAL: "political",
};

// Category colors (hex codes)
export const POST_CATEGORY_COLORS = {
  general: "#2563eb", // Blue (primary-600)
  event: "#8b5cf6", // Purple
  safety: "#dc2626", // Red (accent-600)
  contract: "#16a34a", // Green (success-600)
  training: "#14b8a6", // Teal
  social: "#ec4899", // Pink
  emergency: "#b91c1c", // Dark Red (error-700)
  grievance_update: "#d97706", // Orange (warning-600)
  financial: "#6366f1", // Indigo
  political: "#FEE000", // Deep Yellow
};

// Category labels
export const POST_CATEGORY_LABELS = {
  general: "General",
  event: "Events",
  safety: "Safety",
  contract: "Contract",
  training: "Training",
  social: "Social",
  emergency: "Emergency",
  grievance_update: "Grievance Update",
  financial: "Financial",
  political: "Political",
};

// Category descriptions
export const POST_CATEGORY_DESCRIPTIONS = {
  general: "General announcements and updates",
  event: "Event-related announcements",
  safety: "Safety updates and alerts",
  contract: "Contract and bargaining updates",
  training: "Training opportunities",
  social: "Social events and activities",
  emergency: "Emergency and urgent notifications",
  grievance_update: "Grievance system updates",
  financial: "Financial updates and reports",
  political: "Political action and lobbying updates",
};

// Category icons (Heroicons)
export const POST_CATEGORY_ICONS = {
  general: "InformationCircleIcon",
  event: "CalendarIcon",
  safety: "ShieldCheckIcon",
  contract: "DocumentTextIcon",
  training: "AcademicCapIcon",
  social: "UserGroupIcon",
  emergency: "ExclamationTriangleIcon",
  grievance_update: "ScaleIcon",
  financial: "CurrencyDollarIcon",
  political: "MegaphoneIcon",
};

// Helper function to get category metadata
export const getCategoryMetadata = (category) => {
  return {
    value: category,
    label: POST_CATEGORY_LABELS[category] || category,
    description: POST_CATEGORY_DESCRIPTIONS[category] || "",
    color: POST_CATEGORY_COLORS[category] || "#6b7280",
    icon: POST_CATEGORY_ICONS[category] || "InformationCircleIcon",
  };
};

// Get all categories as an array
export const getAllCategories = () => {
  return Object.values(POST_CATEGORIES).map(getCategoryMetadata);
};

// Validate if a string is a valid category
export const isValidCategory = (category) => {
  return Object.values(POST_CATEGORIES).includes(category);
};
